<template>
  <DashboardTableWrapper
    title="Top produits"
    :loading="loading"
    :error="error"
    :has-data="!!data && data.length > 0"
    @retry="refresh"
  >
    <table class="w-full text-sm">
      <thead>
        <tr class="bg-gray-50 text-left">
          <th class="px-4 py-3 font-semibold text-gray-600">#</th>
          <th class="px-4 py-3 font-semibold text-gray-600">Produit</th>
          <th class="px-4 py-3 font-semibold text-gray-600">SKU</th>
          <th class="px-4 py-3 font-semibold text-gray-600 cursor-pointer hover:text-primary" @click="sortBy('qty_sold')">
            Qte vendue {{ sortIcon('qty_sold') }}
          </th>
          <th class="px-4 py-3 font-semibold text-gray-600 cursor-pointer hover:text-primary" @click="sortBy('revenue')">
            CA {{ sortIcon('revenue') }}
          </th>
          <th class="px-4 py-3 font-semibold text-gray-600 cursor-pointer hover:text-primary" @click="sortBy('nb_sales')">
            Nb ventes {{ sortIcon('nb_sales') }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, idx) in sortedData" :key="item.id" class="border-t border-gray-100 hover:bg-gray-50">
          <td class="px-4 py-3 text-gray-400">{{ idx + 1 }}</td>
          <td class="px-4 py-3 font-medium text-gray-800">{{ item.name }}</td>
          <td class="px-4 py-3 text-gray-500">{{ item.sku }}</td>
          <td class="px-4 py-3 font-semibold">{{ item.qty_sold }}</td>
          <td class="px-4 py-3 font-semibold text-primary">{{ formatCurrency(item.revenue) }}</td>
          <td class="px-4 py-3">{{ item.nb_sales }}</td>
        </tr>
      </tbody>
    </table>
  </DashboardTableWrapper>
</template>

<script setup>
import { ref, computed } from 'vue'
import { useDashboard } from '@/composables/useDashboard'
import { useDateRange } from '@/composables/useDateRange'
import { formatCurrency } from './helpers'
import DashboardTableWrapper from './DashboardTableWrapper.vue'

const { dateParams } = useDateRange()

const params = computed(() => ({
  ...dateParams.value,
  limit: 10
}))

const { data, loading, error, refresh } = useDashboard('/dashboard/tables/top-products', params)

const sortField = ref('qty_sold')
const sortDir = ref('desc')

const sortBy = (field) => {
  if (sortField.value === field) {
    sortDir.value = sortDir.value === 'asc' ? 'desc' : 'asc'
  } else {
    sortField.value = field
    sortDir.value = 'desc'
  }
}

const sortIcon = (field) => {
  if (sortField.value !== field) return ''
  return sortDir.value === 'asc' ? '↑' : '↓'
}

const sortedData = computed(() => {
  if (!data.value) return []
  return [...data.value].sort((a, b) => {
    const m = sortDir.value === 'asc' ? 1 : -1
    return (a[sortField.value] - b[sortField.value]) * m
  })
})
</script>
